import { FC } from 'react'
import { RouteComponentProps } from '@reach/router'
import { StationBallotList } from './StationBallotList'

export const StationBallotContainer: FC<RouteComponentProps> = () => {
  return <StationBallotList />
}
